import { getLecturerList, getLecturerListByClassId, sendEmailLecturerByClassId } from "@/services/lecturer.service";

// initial state
const state = () => ({
  lecturerModel: {},

  lecturerList: [],
});

// mutations
const mutations = {
  setLecturerModel(state, data) {
    state.lecturerModel = data;
  },

  setLecturerList(state, data) {
    state.lecturerList = data;
  },
};

// actions
const actions = {
  async loadLecturerList(vuexContext, centerId) {
    return await getLecturerList(centerId).then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        item.value = item.personId;
        item.label = `${item.name} ${item.lastName}`;
      });

      vuexContext.commit("setLecturerList", data);
      return data;
    });
  },

  async sendEmailLecturerByClassId(vuexContext, classId) {
    return await sendEmailLecturerByClassId(classId).then((response) => {
      let data = response.data;
      return data;
    });
  },

  async loadGetLecturerListByClassId(vuexContext, co) {
    return await getLecturerListByClassId(co).then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        item.value = item.personId;
        item.label = `${item.name} ${item.lastName}`;
      });

      vuexContext.commit("setLecturerList", data);
      return data;
    });
  },

  addLecturerList(vuexContext, data) {
    vuexContext.commit("setLecturerList", data);
  },

  addLecturerModel(vuexContext, data) {
    vuexContext.commit("setLecturerModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
